// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1081":"58f92bcb","3705":"a21cc537"}[chunkId] + ".chunk.css";
};